module.exports = __webpack_public_path__ + "img/banner-6.636aa542.png";